import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import {
  DataGrid,
  GridToolbarExport,
  GridToolbarContainer,
} from "@material-ui/data-grid";
import { makeStyles } from "@material-ui/core/styles";
import { Box, IconButton } from "@material-ui/core";
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from "@material-ui/icons";
import {
  firstDateOfMonth,
  getPrevMonthDay,
  getNextMonthDay,
  getYearMonthKor,
} from "../calendar";
import { reqSettlement } from "./api";
import FoodangLoading from "../common/components/FoodangLoading";
import { usePermissions } from "react-admin";
import { Actions, Resources, useHasPermissions } from "../lib/react-admin-loopback";

const useStyles = makeStyles((theme) => ({
  paper: {
    textAlign: "center",
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
}));

// DataGrid column 설정
const columns = [
  { field: "id", headerName: "ID", width: 70 },
  { field: "name", headerName: "업체명", width: 400 },
  { field: "totalQty", type: "number", headerName: "총 식수량", width: 130 },
  { field: "kpi", type: "number", headerName: "KPI", width: 130 },
  { field: "sellAmount", type: "number", headerName: "매출액", width: 130 },
  { field: "adjust", type: "number", headerName: "조정액", width: 130 },
  { field: "opeationFee", type: "number", headerName: "수수료", width: 130 },
  { field: "calculated", type: "number", headerName: "정산액", width: 130 },
];

const CustomerSettleList = () => {
  const history = useHistory();
  const classes = useStyles();
  const [firstDate, setFirstDate] = useState(firstDateOfMonth(new Date()));
  const dataRef = useRef({
    settledata: [], //  정산 data fetched
    revenue: [], // KPI 자료
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const hasPermission = useHasPermissions(
    Resources.CustomerOrders,
    Actions.List,
    () => {
      alert('권한이 없습니다.');
      history.push('/schedules');
    }
  );

  const hasShowPermission = useHasPermissions(
    Resources.CustomerOrders,
    Actions.Show,
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        // load 정산 자료
        setLoading(true);
        const { data } = await reqSettlement(firstDate);

        dataRef.current.settledata = data.settlement;
        dataRef.current.revenue = data.total;
        console.log(dataRef.current.settledata);
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
        // LATER server logging
        console.error(err);
      }
    };
    fetchData();
  }, [firstDate]);

  //이전달
  const handleClickPrev = () => {
    setFirstDate(getPrevMonthDay(firstDate));
  };

  // 다음달
  const handleClickNext = () => {
    setFirstDate(getNextMonthDay(firstDate));
  };
  return (
    <div style={{ height: "100%", width: "100%" }}>
      {loading ? <FoodangLoading /> : null}

      <Paper className={classes.paper}>
        <Box>
          <IconButton aria-label="go to prev" onClick={handleClickPrev}>
            <ChevronLeftIcon />
          </IconButton>
          <span>{getYearMonthKor(firstDate)}</span>
          <IconButton aria-label="go to next" onClick={handleClickNext}>
            <ChevronRightIcon />
          </IconButton>
        </Box>
      </Paper>
      <Paper>
        <Box className={classes.root}>
          <TextField
            label="총 매출"
            value={dataRef.current.revenue.calculated}
            name="numberformat"
            id="formatted-numberformat-input"
            InputProps={{
              readOnly: true,
            }}
            inputProps={{
              style: { textAlign: "right" },
            }}
          />
          <TextField
            label="총 KPI"
            value={dataRef.current.revenue.kpi}
            name="numberformat"
            id="formatted-numberformat-input"
            InputProps={{
              readOnly: true,
            }}
            inputProps={{
              style: { textAlign: "right" },
            }}
          />
        </Box>
      </Paper>
      <br />
      <DataGrid
        rows={dataRef.current.settledata}
        columns={columns}
        pageSize={30}
        onRowClick={(row) => {
          if (hasShowPermission) {
            history.push(
              `/customer/settlement?id=${row.row.id}&name=${row.row.name}`
            );
          }
        }}
        components={{
          Toolbar: Toolbar,
        }}
      />
    </div>
  );
};

const Toolbar = () => (
  <GridToolbarContainer>
    <GridToolbarExport
      csvOptions={{
        fileName: '고객사정산리스트',
        utf8WithBom: true,
      }}
    />
  </GridToolbarContainer>
);

export default CustomerSettleList;
